import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getOrderReport } from 'services/reports/order.service';

/**
 * Custom hook to fetch and cache the order report.
 * @param {Object} params - Query filter parameters
 * @returns {Object} React Query hook result
 */
export default function useOrderReport(params) {
  return useQuery({
    queryKey: ['report', 'order', params],
    queryFn: () => getOrderReport(params),
    placeholderData: keepPreviousData,
    staleTime: 30000,
    refetchOnWindowFocus: false
  });
}
